export default __webpack_public_path__ + "static/media/Rkids.2af7bcb7.svg";